import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.companyinfo');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ElementRef, ViewChild } from '@angular/core';
import { ClassicEditor, CKEditorPlugins } from "src/libs/portal/season/ckeditor";
import $ from "jquery";
import moment from "moment";

@Component({
    selector: 'wiz-page-companyinfo',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.companyinfo/view.scss */
/* src/app/page.companyinfo/view.scss: no such file or directory */`],
})
export class PageCompanyinfoComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    @ViewChild('editor')
    public editorElement: ElementRef;
    public post_id: any;
    public comments: any;
    public vote: any;
    public nickname: any;
    public comment_text: any;

    public items: any = [];
    public loaded: boolean = false;

    public item: any = {};
    public editor: any;

    public company_id: any = null;
    public post_id: any = null;

    public data: any = {
        bussinessNumber: '',
        companyName: ''
    };

    public search: any = {
        page: 1,
        text: "",
    };

    public pagination: any = {
        end: -1,
        start: -1,
    };

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(false, "/landing");

        const { code, data } = await wiz.call("getSession");
        if (data) {
            this.company_id = data['id']
        }

        await this.load();
    }

    public async load(page: number = 1) {
        if (this.company_id) {
            this.search.company_id = this.company_id;
            this.search.category = "news";

            this.search.page = page;
            this.loaded = false;
            this.items = [];
            let body = JSON.parse(JSON.stringify(this.search));
            body.category = "news";
            const { code, data } = await wiz.call("search", body);
            if (code != 200) return;
            let { rows, lastpage } = data;
            const startpage = Math.floor((page - 1) / 10) * 10 + 1;
            this.items = rows;
            this.pagination.start = startpage;
            this.pagination.end = lastpage;
            this.loaded = true;
        }

        await this.service.render();
    }

    public async alert(message: string, status: string = 'error', cancel: any = false, action: string = '확인') {
        return await this.service.alert.show({
            title: "",
            message: message,
            cancel: cancel,
            actionBtn: status,
            action: action,
            status: status
        });
    }

    public async login() {
        let comLoginData = JSON.parse(JSON.stringify(this.data));

        if (!comLoginData.bussinessNumber) {
            this.alert('사업자등록번호를 입력해주십시오.')
            return
        }

        if (!comLoginData.companyName) {
            this.alert('업체명을 정확히 입력해주십시오.')
            return
        }

        let { code, data } = await wiz.call("login", comLoginData);

        if (code != 200) {
            this.alert(data)
            return
        }

        this.company_id = data['id']

        await this.load();
    }

    public async printsession() {
        let { code, data } = await wiz.call("getSession");

        console.log(data);
    }

    public async delsession() {
        const { code, data } = await wiz.call("delSession");

        this.company_id = null;

        await this.service.render();
    }

    public async update() {
        this.item.content = this.editor.data.get();//.replace("\n", "<br />");
        this.item.company_id = this.company_id;
        let data: any = JSON.stringify(this.item);
        await wiz.call("update", { data: data });
        await this.alert('저장되었습니다', 'success');

        if (!this.item.id) {
            await this.previous();
            await this.load(this.search.page);
        }
    }

    public async delete() {
        let res: any = await this.alert("정말로 삭제하시겠습니까?", "", "error", "삭제", "취소");
        if (!res) return;
        await wiz.call("delete", { id: this.item.id });
        await this.previous();
        await this.load(this.search.page);
    }

    public async upload() {
        let files = await this.service.file.select();
        if (files.length == 0) return;

        await this.service.loading.show();

        if (!this.item.extra.attachments) this.item.extra.attachments = [];

        for (let i = 0; i < files.length; i++) {
            let fd = new FormData();
            console.log(files[i])
            fd.append('upload', files[i]);
            let fdurl = '/file/upload';
            const { url } = await this.service.file.upload(fdurl, fd, async (percent: number, total: number, position: number) => { });
            this.item.extra.attachments.push({ name: files[i].name, url: url });
        }

        await this.service.loading.hide();
        this.service.render();
    }

    public async removeFile(file) {
        let res: any = await this.alert("정말로 삭제하시겠습니까?", "", "error", "삭제", "취소");
        if (!res) return;
        this.item.extra.attachments.remove(file);
        this.service.render();
    }

    public async select(item) {
        if (item.id != 'new') {
            const { code, data } = await wiz.call("get", { id: item.id });
            if (code != 200) return await this.previous();
            item = data.item;
            this.vote = data.vote;
            this.comments = data.comments;
        }

        this.post_id = item.id;
        await this.service.render();

        let element: any = this.editorElement.nativeElement;

        if ($(element).parent().find(".ck-content").length == 0) {
            let toolbar = 'heading | bold italic strikethrough underline | blockQuote code | bulletedList numberedList | outdent indent | uploadImage insertTable link codeBlock horizontalLine | specialCharacters'.split(' ');

            this.editor = await ClassicEditor.create(element, {
                toolbar: {
                    items: toolbar,
                    shouldNotGroupWhenFull: true
                },
                removePlugins: ["MediaEmbedToolbar"],
                plugins: CKEditorPlugins,
                simpleUpload: {
                    uploadUrl: '/file/upload'
                }
            });
        }

        if (item.id == 'new') {
            this.item = {
                category: 'news',
                fund_id: this.company_id,
                title: '',
                content: '',
                level: '일반',
                status: 'publish',
                mode: '일반',
                extra: {},
                created: moment().format("YYYY-MM-DD")
            };
        } else {
            this.item = item;
            if (!this.item.level) item.level = '일반';
            this.item.created = moment(item.created).format("YYYY-MM-DD");
        }

        this.editor.data.set(this.item.content);

        if (!this.item.extra.vote) this.item.extra.vote = [];

        await this.service.render();
    }

    public async previous() {
        this.post_id = null;
        this.vote = null;
        this.comments = null;
        this.item = {};
        await this.service.render();
    }
}

export default PageCompanyinfoComponent;